import React from 'react';
import Switch from '@mui/material/Switch';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import FormControlLabel from '@mui/material/FormControlLabel';
import { Tooltip } from '@mui/material';

const switchTheme = createTheme({
  palette: {
    primary: {
      main: '#7165E3',
    },
  },
});

const CommonSwitch = ({
  checked,
  onChange,
  label,
  className,
  disabled,
  isToolTip,amendreadOnly,
  toolTipLabel,
  ...rest
}) => {
  const contractStatus = sessionStorage.getItem('Selected Contract Status');
  const isDisabled = contractStatus === 'ACTIVE' ? true : disabled || amendreadOnly || false;

  const switchControl = (
    <FormControlLabel
      control={
        <Switch
          className={className}
          onChange={onChange}
          checked={checked}
          disabled={isDisabled}
          {...rest}
        />
      }
      label={label}
      className={className}
    />
  );

  return (
    <ThemeProvider theme={switchTheme}>
      {isToolTip ? (
        <Tooltip title={toolTipLabel} placement="top">
          <span>{switchControl}</span>
        </Tooltip>
      ) : (
        switchControl
      )}
    </ThemeProvider>
  );
};

export default CommonSwitch;
